import { Autocomplete, TextField } from '@mui/material';
import { Languages } from '../../types/Languages';

const LANGUAGE_OPTIONS = Object.keys(Languages).filter((k) =>
  isNaN(Number(k))
) as Array<keyof typeof Languages>;

type Props = {
  value?: string | null;
  onChange: (language: string) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: string;
};

const LanguageSelect = ({
  value,
  onChange,
  label = 'Alapértelmezett nyelv',
  disabled = false,
  required = false,
  error = false,
  helperText,
}: Props) => {
  const selected =
    value && LANGUAGE_OPTIONS.includes(value as any) ? value : 'hu';

  return (
    <Autocomplete
      options={LANGUAGE_OPTIONS}
      value={selected}
      disabled={disabled}
      onChange={(_e, next) => onChange(next || 'hu')}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          error={error}
          helperText={helperText}
          fullWidth
        />
      )}
    />
  );
};

export default LanguageSelect;
